import { AutomationStep } from '@/types/automationSteps.ts';
import { useUpdateStepFields } from '@/hooks/api/steps/useUpdateStepFields.ts';
import StyledTextInput from '@/components/StyledInputFields/StyledTextInput.tsx';
import { STEP_FIELD_MAX_LENGTH } from '@/utils/constants.ts';

type props = {
  step: AutomationStep;
};

type CommonFields = {
  output_name: string;
};

const OutputNameField = ({ step }: props) => {
  const { fields, onChange } = useUpdateStepFields<CommonFields>({ step });

  return (
    <>
      {/*<Divider mt="xs" mb={'0'} />*/}
      <StyledTextInput
        label="Output Name"
        value={fields.output_name}
        placeholder="Name of the output produced by this step"
        onChange={(event) => {
          const value = event.currentTarget.value.replace(/[/\n]/g, '');
          onChange({ output_name: value });
        }}
        required={false}
        maxLength={STEP_FIELD_MAX_LENGTH}
      />
    </>
  );
};

export default OutputNameField;
